/*
 * Copyright (c) 2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import {useCallback, useEffect, useRef} from "react";

function useEvent(handler) {
    const handlerRef = useRef(null);

    // Update ref to always point to latest handler
    useEffect(() => {
        handlerRef.current = handler;
    });

    return useCallback((...args) => {
        const fn = handlerRef.current;
        return fn?.(...args);
    }, []);
}

export default useEvent;